var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 17.5H13.3333C14.4384 17.5 15.4982 17.061 16.2796 16.2796C17.061 15.4982 17.5 14.4384 17.5 13.3333V10.8333C17.5 10.1703 17.2366 9.53441 16.7678 9.06557C16.2989 8.59672 15.663 8.33333 15 8.33333H14.1667V6.66667C14.1667 5.5616 13.7277 4.50179 12.9463 3.72039C12.1649 2.93899 11.1051 2.5 10 2.5H6.66667C5.5616 2.5 4.50179 2.93899 3.72039 3.72039C2.93899 4.50179 2.5 5.5616 2.5 6.66667V13.3333C2.5 14.4384 2.93899 15.4982 3.72039 16.2796C4.50179 17.061 5.5616 17.5 6.66667 17.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 7.08331C5.8335 6.75179 5.96519 6.43385 6.19961 6.19943C6.43403 5.96501 6.75198 5.83331 7.0835 5.83331H9.5835C9.91502 5.83331 10.233 5.96501 10.4674 6.19943C10.7018 6.43385 10.8335 6.75179 10.8335 7.08331C10.8335 7.41483 10.7018 7.73278 10.4674 7.9672C10.233 8.20162 9.91502 8.33331 9.5835 8.33331H7.0835C6.75198 8.33331 6.43403 8.20162 6.19961 7.9672C5.96519 7.73278 5.8335 7.41483 5.8335 7.08331ZM5.8335 12.9166C5.8335 12.5851 5.96519 12.2672 6.19961 12.0328C6.43403 11.7983 6.75198 11.6666 7.0835 11.6666H12.9168C13.2483 11.6666 13.5663 11.7983 13.8007 12.0328C14.0351 12.2672 14.1668 12.5851 14.1668 12.9166C14.1668 13.2482 14.0351 13.5661 13.8007 13.8005C13.5663 14.0349 13.2483 14.1666 12.9168 14.1666H7.0835C6.75198 14.1666 6.43403 14.0349 6.19961 13.8005C5.96519 13.5661 5.8335 13.2482 5.8335 12.9166Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/content-icon.4d0e0ae3e4a3a0e1fa7a747c4ef5593c.svg";
export { ForwardRef as ReactComponent };